import { Entity } from './types'

export const columnKeysSimple = [Entity.Title, Entity.TotalCount, Entity.TotalSum]

export const columnKeysSimpleHeaders = [
  [Entity.Title, Entity.Total],
  [Entity.TotalCount, Entity.TotalSum],
]
